import { render, staticRenderFns } from "./contentVideo.vue?vue&type=template&id=7038996d&scoped=true&"
import script from "./contentVideo.vue?vue&type=script&lang=js&"
export * from "./contentVideo.vue?vue&type=script&lang=js&"
import style0 from "./contentVideo.vue?vue&type=style&index=0&id=7038996d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038996d",
  null
  
)

export default component.exports